<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="search">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-search"></i> Pesquisar
                        </div>
                        <div class="card-block">
                            <div class="form-group row">
                                <div class="col-md-6 col-xs-12">
                                    <label>Nome</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="filter.nome"
                                    />
                                </div>
                                <div class="col-md-6">
                                    <label>Email*</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="filter.email"
                                    />
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-3">
                                    <label>CPF</label>
                                    <masked-input
                                        v-model.trim="filter.cpf"
                                        mask="111.111.111-11"
                                        class="form-control"
                                    ></masked-input>
                                </div>
                                <div class="col-md-3">
                                    <label>Telefone</label>
                                    <masked-input
                                        v-model.trim="filter.telefone"
                                        mask="(11) 11111-1111"
                                        class="form-control"
                                    />
                                </div>
                            </div>
                            <hr />
                            <div class="form-group row">
                                <div class="col-md-3">
                                    <ul class="toggle-list">
                                        <li>
                                            <label>Ativo</label>
                                            <input-toggle
                                                v-model="filter.ativo"
                                                :value="filter.ativo"
                                            ></input-toggle>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group row">
                                <div class="col-md-6 text-left">
                                    <button type="button" @click="create" class="btn btn-primary">
                                        Novo Usuário
                                        <i class="fa fa-angle-right"></i>
                                    </button>
                                </div>
                                <div class="col-md-6 text-right">
                                    <button
                                        type="button"
                                        @click="clean"
                                        class="btn btn-primary"
                                    >Limpar</button>
                                    <button type="submit" class="btn btn-default">
                                        <i class="fa fa-search"></i> Pesquisar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <dw-table-header :size="size" @finish="updateSize" :pagination="list"></dw-table-header>
                    </div>
                    <div class="card-block">
                        <table class="table table-bordered table-striped table-md">
                            <dw-table-head :headers="headers" :editable="true" @update="sort"></dw-table-head>
                            <tbody>
                                <tr v-for="item in list.rows">
                                    <td :data-label="headers[0].name">{{ item.id }}</td>
                                    <td :data-label="headers[1].name">
                                        {{ item.nome }}
                                        <span
                                            v-if="item.ativo"
                                            class="badge badge-success"
                                        >Ativo</span>
                                        <span v-else class="badge badge-danger">Inativo</span>
                                    </td>
                                    <td
                                        :data-label="headers[2].name"
                                    >{{ item.nascimento | formatDate('DD/MM/YYYY') }}</td>
                                    <td :data-label="headers[3].name">{{ item.telefone }}</td>
                                    <td :data-label="headers[4].name">{{ item.email }}</td>
                                    <td :data-label="headers[5].name">{{ item.cpf }}</td>
                                    <td
                                        :data-label="headers[6].name"
                                    >{{ item.criado_em | formatDate('DD/MM/YYYY HH:mm') }}</td>
                                    <td>
                                        <button
                                            class="btn btn-primary btn-sm"
                                            @click="edit(item.id)"
                                        >
                                            <i class="far fa-edit"></i>
                                        </button>
                                        <button
                                            class="btn btn-danger btn-sm"
                                            @click="remove(item.id)"
                                        >
                                            <i class="far fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <dw-pagination
                            :pagination="list"
                            :page="page"
                            @update="fetchData"
                            :offset="size"
                        ></dw-pagination>
                    </div>
                </div>
            </div>
            <!--/.col-->
        </div>
        <!--/.row-->
    </div>
</template>

<script>
import {
    isUndefinedOrNullOrEmpty,
    clearCpfCnpj,
    clearPhone
} from "@/services/string";
import Collections from "@/helpers/collections";
import Facade from "../../facade/facade";
const facade = new Facade();

export default {
    data() {
        return {
            headers: [
                { name: "Cód.", key: "id" },
                { name: "Nome", key: "nome" },
                { name: "Data Nascimento", key: "nascimento" },
                { name: "Telefone", key: "telefone" },
                { name: "E-mail", key: "email" },
                { name: "CPF", key: "cpf" },
                { name: "Data de Criação", key: "criado_em" }
            ],
            list: {},
            filter: {
                nome: "",
                cpf: "",
                telefone: "",
                senha: "",
                email: "",
                nascimento: moment().format("YYYY-MM-DD"),
                ativo: true,
                perfil: "",
                sexo: ""
            },
            size: 20,
            page: 0,
            order: ["id", "ASC"]
        };
    },
    computed: {
        isAdmin() {
            return facade.isAdmin();
        }
    },
    methods: {
        sort(data) {
            this.order = [data.key, data.direction];
            this.fetchData(this.page);
        },
        clean() {
            this.filter = {
                nome: "",
                email: "",
                cpf: "",
                telefone: "",
                senha: ""
                // perfil: '',
                // id_empresa: '',
                // ativo: true
            };
        },
        create() {
            this.$router.push({ name: "new-user" });
        },
        edit(id) {
            this.$router.push({ name: "edit-user", params: { id: id } });
        },
        remove(id) {
            this.$swal({
                title: "Você tem certeza?",
                text: "Não será possível reverter esta operação",
                showCancelButton: true,
                confirmButtonText: "Sim, deletar!",
                cancelButtonText: "Não, cancelar!"
            }).then(
                () => {
                    this.$loading.show(true);

                    let ret = facade.deleteUser(id);
                    ret.then(response => {
                        this.$notify.success(
                            "",
                            "Registro removido com sucesso."
                        );
                        this.fetchData(0);
                        this.$loading.show(false);
                    }).catch(e => {
                        this.$notify.error(
                            "Erro!",
                            "Ocorreu um problema ao deletar o usuário."
                        );
                        this.$loading.show(false);
                    });
                },
                dismiss => {}
            );
        },
        fetchData(page) {
            let vm = this;
            vm.page = page;

            let params = {
                params: { page: page, size: vm.size, order: vm.order }
            };

            let clone = _.cloneDeep(this.filter);
            if (!isUndefinedOrNullOrEmpty(clone.telefone))
                clone.telefone = clearPhone(clone.telefone);
            if (!isUndefinedOrNullOrEmpty(clone.cpf))
                clone.cpf = clearCpfCnpj(clone.cpf);

            for (let key in clone) {
                if (clone.hasOwnProperty(key)) {
                    params["params"][key] = clone[key];
                }
            }

            this.$loading.show(true);
            params.cpfCnpj = clearCpfCnpj(params.cpfCnpj);
            let ret = facade.listUser(params);
            ret.then(response => {
                vm.list = response.data.data;
                this.$loading.show(false);
            }).catch(e => {
                this.$notify.error(
                    "Erro!",
                    "Ocorreu um problema ao listar os usuários."
                );
                this.$loading.show(false);
            });
        },
        search() {
            this.fetchData(0);
        },
        updateSize(value) {
            let vm = this;
            vm.size = value;
            this.fetchData(0);
        }
    },
    beforeMount() {
        this.fetchData(0);
    }
};
</script>



// WEBPACK FOOTER //
// List.vue?786f7b58